import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ModelGETPreset, type IModelGETPresetRequest, type IModelGETPresetResponse } from "./dto/preset.dto";

import { PresetRepository } from "./preset.repository";


export class PresetService extends BaseService {
  private presetRepository = new PresetRepository(this.api, this.configService);

  async getPreset(params: IModelGETPresetRequest): Promise<IModelResponse<ModelGETPreset[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelGETPreset[]> = {
      data: [],
    };

    try {
      const res = await this.presetRepository.getPreset(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e: IModelGETPresetResponse) => new ModelGETPreset(e))
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getPreset', params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetService.name);
    }

    return dataResult;
  }

  async deletePreset(params: string): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.presetRepository.deletePreset(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('deletePreset', params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetService.name);
    }

    return dataResult;
  }

  async getPresetFile(fileName: string): Promise<any> {
    let dataResult;
    try {
      const res = await this.presetRepository.getPresetFile(fileName,);
      const resData = res.data.value;
      if (resData) {
        dataResult = resData;
        console.log('getPresetFile', fileName, resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, PresetService.name);
    }
    return dataResult;
  }
}
